module.exports = __webpack_public_path__ + "media/images/bg-whatwedo-71bb223acbd63da0b7f816d6984430f0.jpg";